/**
 * Project: Academy V2
 * File: TrueOrFalseIcon.tsx
 * Author: Colopi Salvatore
 * Author URI: https://salvatorecolopi.com
 * Created: Tue Jun 04 2024 at 19:39:55
 *
 * Copyright (c) 2024 Edusogno. All rights reserved.
 */

import React from "react";

interface TrueOrFalseIconProps extends React.SVGAttributes<SVGElement> {
  color?: string;
}

const TrueOrFalseIcon: React.FC<TrueOrFalseIconProps> = ({ color = "#8065C9", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.086 1.166h10.75v10.75h-10.75zM20.086 19.082h10.75v10.75h-10.75z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.687 3.32c.206-.262.318-.608.313-.965a1.513 1.513 0 0 0-.342-.951A1.087 1.087 0 0 0 10.854 1a1.073 1.073 0 0 0-.816.37L3.86 8.672 1.962 6.428a1.073 1.073 0 0 0-.816-.37c-.302.007-.59.151-.804.404A1.513 1.513 0 0 0 0 7.413c-.005.357.107.703.313.965l2.723 3.219c.219.258.515.403.825.403.309 0 .605-.145.824-.403l7.002-8.277ZM2.366 19.433a1.365 1.365 0 0 0-2.238 1.49c.072.167.176.317.307.443L3.569 24.5.435 27.634a1.367 1.367 0 1 0 1.931 1.931L5.5 26.431l3.134 3.134a1.367 1.367 0 1 0 1.931-1.931L7.431 24.5l3.134-3.134a1.368 1.368 0 1 0-1.931-1.931L5.5 22.569l-3.134-3.136Z"
      fill={color}
    />
  </svg>
);

export default TrueOrFalseIcon;
